<script setup>
import { ref } from 'vue';
import Gallery from '@components-molecules/Gallery.vue';

const { mediaUuids, page } = window;
const hashId = window.hashId ?? null;
const { sellerOrganizationId } = window;

const modalIsOpen = ref(false);

const PAGE = {
  OFFER_DETAILS: 'offer_details',
  SPACE_DETAILS: 'space_details',
};
</script>

<template>
  <div>
    <button class="gallery-show-button" @click="modalIsOpen = true" />

    <Gallery
      v-if="page === PAGE.OFFER_DETAILS && hashId"
      :media-uuids="mediaUuids"
      :hash-id="hashId"
      :is-open="modalIsOpen"
      :seller-organization-id="sellerOrganizationId ?? null"
      has-cta-layer
      @close="modalIsOpen = false"
    />

    <Gallery
      v-else
      :media-uuids="mediaUuids"
      :is-open="modalIsOpen"
      :seller-organization-id="sellerOrganizationId ?? null"
      @close="modalIsOpen = false"
    />
  </div>
</template>
